const serviceData = [
    { icon: 'grid', title: 'Pay Online', text: 'Go to <a href="https://www.myfexaccount.com" target="blank">Fex Pay</a> to pay online' },
    { icon: 'edit', title: 'Pay by Phone', text: 'There\'s no fee to use our automated payment system, just follow the prompts.' }
];

export { serviceData };
